import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { TextWidth, TextWidthExtended } from '@ta-interaktiv/react-disco-grid'
import { IsThisAI } from 'components/IsThisAI'
import { Header } from 'components/Header/Header'
import { Definition } from 'components/Definition'
import { Learning } from 'components/Learning'
import { Difference } from 'components/Difference/Difference'
import { TrainingSize } from 'components/TrainingSize'
import { Probability } from 'components/Probability'
import { Trick } from 'components/Trick'
import { TrickTwo } from 'components/TrickTwo'
import { TrickThree } from 'components/TrickThree/TrickTwo'

const isDev = window.document.title === 'TA-Interaktiv Microfrontend'

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const visualization = properties?.visualization || 'header'

  console.log(visualization)
  return (
    <AppContainer className={globalClasses.join(' ')} $colorMode={colorMode}>
      {(visualization === 'header' || isDev) && (
        <Header colorMode={colorMode} tenant={tenant?.key || 'tagesanzeiger'} />
      )}
      {(visualization === 'trick' || isDev) && <Trick />}
      {(visualization === 'tricktwo' || isDev) && <TrickTwo />}
      {/* {(visualization === 'trickthree' || isDev) && <TrickThree />} */}
      {(visualization === 'trainingsize' || isDev) && (
        <TextWidth>
          <DeSwim>
            <TrainingSize />
          </DeSwim>
        </TextWidth>
      )}
      {(visualization === 'probabilty' || isDev) && (
        <TextWidth>
          <DeSwim>
            <Probability />
          </DeSwim>
        </TextWidth>
      )}
      {(visualization === 'definition' || isDev) && (
        <TextWidth>
          <DeSwim>
            <Definition />
          </DeSwim>
        </TextWidth>
      )}
      {(visualization === 'difference' || isDev) && (
        <TextWidthExtended>
          <DeSwim>
            <Difference colorMode={colorMode} />
          </DeSwim>
        </TextWidthExtended>
      )}
      {(visualization === 'learning' || isDev) && (
        <TextWidthExtended>
          <Learning colorMode={colorMode} />
        </TextWidthExtended>
      )}
      {(visualization === 'identify' || isDev) && (
        <TextWidth>
          <DeSwim>
            <IsThisAI colorMode={colorMode} />
          </DeSwim>
        </TextWidth>
      )}
    </AppContainer>
  )
}

const DeSwim = styled.div`
  max-width: 100%;
  overflow: hidden;
`

const AppContainer = styled(TamediaStyles)<{ colorMode: 'light' | 'dark' | undefined }>`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  background-color: var(--site-background);
`
export default MainComponent
